import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import AttendanceInfoService from "../../../../../../services/reports/attendance-info-service.jsx";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";

export default function DispatchTable({ title, data }) {
    const dispatch = data?.attendance?.dispatch ?? [];
    const boName = data?.attendance?.bo ?? {};
    const [gridApi, setGridApi] = useState(null);

    const columnDefs = useMemo(() => ([
        {
            headerName: "Talão",
            field: "dispatch_numbercheckbook",
            flex: 1,
                cellRenderer: ({ data, value }) => {
                    const dispatchId = data?.dispatch_id;

                    if (!value) {
                        return "Sem talão";
                    }

                    return (
                        <button
                            type="button"
                            className="text-[#1588F3] underline cursor-pointer print:text-inherit print:!no-underline"
                            onClick={() => {window.open(AttendanceInfoService.getDispatch(dispatchId), "_blank")}}
                        >
                            {value}
                        </button>
                    )
                }
        },
        {
            headerName: boName,
            field: "dispatch_occurrencenumber",
            flex: 1,
            cellRenderer: ({ data, value }) => {
                const occurrenceId = data?.dispatch_occurrencenumber;

                return (
                    <button
                        type="button"
                        className="text-[#1588F3] underline cursor-pointer print:text-black print:!no-underline"
                        onClick={() => {window.open(AttendanceInfoService.getOccurrence(occurrenceId), "_blank")}}
                    >
                        {value}
                    </button>
                )
            }
        },
        { headerName: "D/H inicial", field: "dispatch_start", flex: 2 },
        { headerName: "D/H final", field: "dispatch_end", flex: 2 },
        { headerName: "Natureza", field: "dispatch_nature", flex: 2 },
        { headerName: "Guarnição", field: "garrison_name", flex: 2 },
        {
            headerName: "Status",
            field: "dispatch_status",
            flex: 1.5,
            cellRenderer: ({ value }) => {
                const isInProgress = !!value;

                return (
                    <span className="flex h-full items-center gap-1">
                        <span
                            className={`h-2.5 w-2.5 rounded-full ${isInProgress ? "bg-[#106b10]" : "bg-[#d1d1d1]"}`}
                        />
                        {isInProgress ? "Em andamento" : "Finalizado"}
                    </span>
                )
            },
        },
    ]), [dispatch]);

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <div className="w-full print:hidden">
                <AgGridReact
                    rowData={dispatch ?? []}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={AgGridUtils.generalTheme({ headerTextColor: "#676a6c" })}
                    suppressRowHoverHighlight={true}
                    domLayout="autoHeight"
                    onGridReady={(params) => setGridApi(params.api)}
                />
            </div>
            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3]">
                <PrintableTableAgGrid
                    gridApi={gridApi}
                    className="!border-0 w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}